import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  getInitalDateRangeForListData,
  isLargeScreen,
} from '../../../../../../global.variable';
import { DataCheckService } from '../../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { getDateTimeRange } from '../../../tableDetails';
import { HolAndMessageService } from '../../hol-and-message.service';

@Component({
  selector: 'gtapp-hand-over-log',
  templateUrl: './hand-over-log.component.html',
  styleUrl: './hand-over-log.component.scss',
  standalone: false,
})
export class HandOverLogComponent implements OnInit, OnDestroy {
  largeView = isLargeScreen;
  // hol variables
  totalRowsHOL: number = 0;
  previousHOL: number = 0;
  pageSizeHOL: number = 10;
  pageNumHOL: number = 1;
  totalPagesHOL: number = 0;
  searchParamsHOL: any;
  sortKeysHOL: any = ['-hand_over_log__updated_at'];
  dateRangeHOL: any;

  otherParamsHOL: any = {
    tableRowStyle: (rowData: any) => {
      if (!rowData?.accepted_at) {
        return {
          'font-weight': '600',
        };
      }
      return {};
    },
  };
  HOLDataList: any = [];

  tableDetailHOL: any = [];

  isAdmin = this.dataCheckService.isUserAdmin();
  draftedHOLExists: boolean = false;

  selectedTab: any;
  tabNames: any = {};

  groupUserCount: any;

  navigationEndSubscription: Subscription = new Subscription();

  urlFragmentDetails: any = {};

  pinnedMessageTab: string = 'Pinned Messages'; // change in pinned message component as well

  constructor(
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private handOverLogService: HolAndMessageService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private route: ActivatedRoute,
  ) {}
  ngOnDestroy(): void {
    if (this.navigationEndSubscription) {
      this.navigationEndSubscription?.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.navigationEndSubscription = this.route.params.subscribe({
      next: (params) => {
        if (this.route.snapshot.fragment) {
          this.urlFragmentDetails = JSON.parse(
            atob(this.route.snapshot.fragment),
          );
        }
      },
    });

    this.getHOLDraftedCount();

    this.tabNames = {
      tab1: 'Received',
      tab2: 'Sent',
    };
    if (this.isAdmin) {
      this.tabNames = {
        tab1: 'Received',
        tab2: 'Sent',
        tab3: 'All Logs',
        tab4: this.pinnedMessageTab,
      };
    }

    if (
      this.urlFragmentDetails &&
      Object.keys(this.urlFragmentDetails)?.length
    ) {
      this.selectedTab = Object.values(this.tabNames)?.includes(
        this.urlFragmentDetails?.selectedTab,
      )
        ? this.urlFragmentDetails?.selectedTab
        : this.tabNames.tab1;
      this.searchParamsHOL = this.urlFragmentDetails?.searchParams;
      this.updateTableDetail(this.urlFragmentDetails?.tableDetail);

      const initialDateRange = getInitalDateRangeForListData(
        this.tableDetailHOL || [],
      );
      this.dateRangeHOL = initialDateRange;
      this.onChangePaginationHOL(this.urlFragmentDetails);
    } else {
      this.selectedTab = this.tabNames.tab1;
      this.updateTableDetail();
      const initialDateRange = getInitalDateRangeForListData(
        this.tableDetailHOL || [],
      );
      this.dateRangeHOL = initialDateRange;
      this.getHOLData();
    }
  }

  selectDropDown(event: any) {
    let selectedTab = event.target.value;
    if (selectedTab) {
      this.changeTab(selectedTab);
    }
  }

  changeTab(tab: any) {
    this.selectedTab = Object.values(this.tabNames)?.includes(tab)
      ? tab
      : this.tabNames.tab1;
    if (this.selectedTab !== this.pinnedMessageTab) {
      this.updateTableDetail();
      const initialDateRange = getInitalDateRangeForListData(
        this.tableDetailHOL || [],
      );
      this.dateRangeHOL = initialDateRange;
      this.searchParamsHOL = {};
      this.reseHOLVariables();
      this.getHOLData();
    }
  }

  onRowClick(data: any) {
    this.router.navigate([
      '/view-hand-over-log',
      {
        hKey: btoa(String(data?.id)),
        gKey: btoa(String(data?.received_by_id)),
      },
    ]);
  }
  getHOLDraftedCount() {
    this.spinnerService.show();
    this.handOverLogService
      .getHandOverLogs({}, { drafted_count: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.draftedHOLExists = response?.data?.drafted_hol_exists;
          this.handOverLogService.updateHOLDraftCount(
            this.draftedHOLExists ? 1 : 0,
          );
          this.spinnerService.hide();

          this.groupUserCount = response?.user_and_group_count?.['2'];
          localStorage.setItem(
            'groupUserCount',
            JSON.stringify(response?.user_and_group_count),
          );
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  getHOLData() {
    let params: any = {};
    switch (this.selectedTab) {
      case this.tabNames.tab1:
        params.received = 1;
        break;
      case this.tabNames.tab2:
        params.sent = 1;
        break;
    }

    let body: any = {};
    if (this.dateRangeHOL) body.date_range = this.dateRangeHOL;
    if (this.searchParamsHOL) {
      body.ui_filters = this.searchParamsHOL;
    }

    if (this.sortKeysHOL) params.sort_key = this.sortKeysHOL;

    if (this.pageSizeHOL) {
      params['rows'] = this.pageSizeHOL;
    }
    if (this.previousHOL) {
      params['previous'] = this.previousHOL;
    }

    this.spinnerService.show();
    this.handOverLogService
      .getHandOverLogs(body, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.totalRowsHOL = response['total_size'];

          this.totalPagesHOL = Math.ceil(this.totalRowsHOL / this.pageSizeHOL);
          this.spinnerService.hide();
          this.otherParamsHOL.paginationData = {
            totalRows: this.totalRowsHOL,
            previousRows: this.previousHOL,
            rows: this.pageSizeHOL,
            pageNum: this.pageNumHOL,
            totalPages: this.totalPagesHOL,
          };

          this.HOLDataList = response?.data;
          this.router.navigate([], {
            fragment: btoa(
              JSON.stringify({
                searchParams: this.searchParamsHOL,
                selectedTab: this.selectedTab,
                tableDetail: this.tableDetailHOL,
                paginationData: this.otherParamsHOL?.paginationData,
              }),
            ),
            queryParams: {},
            replaceUrl: true, // Replaces the current URL without adding a new history entry
          });
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  onChangePaginationHOL(data: any) {
    this.previousHOL = data?.paginationData?.previousRows;
    this.pageNumHOL = data?.paginationData?.pageNum;
    this.pageSizeHOL = data?.paginationData?.rows;

    this.getHOLData();

    this.otherParamsHOL.paginationData = {
      ...data?.paginationData,
    };
  }
  sortColumnHOL(sortData: any) {
    this.reseHOLVariables();
    this.sortKeysHOL = sortData?.sortList || [];
    this.getHOLData();
  }

  searchColumnHOL(searchData: any) {
    this.reseHOLVariables();
    this.dateRangeHOL = null;
    this.searchParamsHOL = searchData?.searchParams || {};

    this.getHOLData();
  }
  reseHOLVariables() {
    this.totalRowsHOL = 0;
    this.previousHOL = 0;
    this.pageSizeHOL = 10;
    this.pageNumHOL = 1;
    this.totalPagesHOL = 0;
    this.otherParamsHOL.paginationData = {
      totalRows: this.totalRowsHOL,
      previousRows: this.previousHOL,
      rows: this.pageSizeHOL,
      pageNum: this.pageNumHOL,
      totalPages: this.totalPagesHOL,
    };
  }
  updateTableDetail(tableInfoFromUrl?: any) {
    let tableDetail: any = [];
    if (this.selectedTab === this.tabNames.tab1) {
      tableDetail = [
        {
          header: 'Date',
          name: 'updated_at',
          datetimeObj: true,
          dateRangeKey: 'hand_over_log__updated_at',
          sortKey: 'hand_over_log__updated_at',
          default: true,
          ...getDateTimeRange(3),
          suffixNestedValue: (row: any) => {
            return `\n${row?.created_by}`;
          },
          suffixStyle: { 'white-space': 'pre-line' },
        },
        {
          header: 'Subject',
          nestedValue: (row: any) => {
            return row?.description?.length > 100
              ? `${row?.description?.slice(0, 100)}...`
              : row?.description;
          },
        },
      ];
    } else if (this.selectedTab === this.tabNames.tab2) {
      tableDetail = [
        {
          header: 'Date',
          name: 'updated_at',
          datetimeObj: true,
          dateRangeKey: 'hand_over_log__updated_at',
          sortKey: 'hand_over_log__updated_at',
          default: true,
          ...getDateTimeRange(3),
          suffixNestedValue: (row: any) => {
            return `\n${row?.received_by}`;
          },
          suffixStyle: { 'white-space': 'pre-line' },
        },
        {
          header: 'Subject',
          searchKey: 'hand_over_log__description',
          nestedValue: (row: any) => {
            return row?.description?.length > 100
              ? `${row?.description?.slice(0, 100)}...`
              : row?.description;
          },
        },
      ];
    } else {
      tableDetail = [
        {
          header: 'Date',
          name: 'updated_at',
          datetimeObj: true,
          dateRangeKey: 'hand_over_log__updated_at',
          sortKey: 'hand_over_log__updated_at',
          default: true,
          ...getDateTimeRange(3),
          suffixNestedValue: (row: any) => {
            return `\n ${row?.created_by} \n`;
          },
          suffixStyle: { 'white-space': 'pre-line' },
        },

        {
          header: 'Subject',
          searchKey: 'hand_over_log__description',
          nestedValue: (row: any) => {
            return row?.description?.length > 100
              ? `${row?.description?.slice(0, 100)}...`
              : row?.description;
          },
        },
        {
          header: 'To',
          name: 'received_by',
        },
      ];
    }

    this.tableDetailHOL = tableInfoFromUrl?.length
      ? tableDetail?.map((orig: any) => {
          const preloaded = tableInfoFromUrl?.find(
            (item: any) => item?.header === orig?.header,
          );

          return {
            ...orig,
            ...preloaded,
          };
        })
      : tableDetail;
  }
}
